import React, { useEffect, useState } from 'react'
import {
  cleanSingleClientMachine,
  getSingleClientMachinery,
  updateClientMachinery,
} from 'features/clientMachinery/clientMachinerySlice'
import { useDispatch, useSelector } from 'react-redux'
import { NavBar } from '../../components/NavBar/NavBar'
import {
  Flex,
  H1WithBack,
  PageWrapper,
  ContentWrapper,
  PageFooter,
  Button,
} from '../../styling/GlobalStyles'
import { MachinerySpecificationTab } from './MachinerySpecificationTab'
import { useParams, useNavigate } from 'react-router-dom'
import { AppDispatch, RootState } from 'store'
import { IMachinery } from 'types/machinery.interface'
import { toast } from 'react-toastify'
import { CancelBtn } from 'components/Button/CancelBtn'

export const EditMachinery = () => {
  const dispatch = useDispatch<AppDispatch>()
  const { singleClientMachine } = useSelector((store: RootState) => store.clientMachinery)
  const { id } = useParams()
  const [state, setState] = useState<IMachinery>(null)

  const navigate = useNavigate()


  useEffect(() => {
    dispatch(getSingleClientMachinery(id))
    return () => {
      dispatch(cleanSingleClientMachine())
    }
  }, [])

  useEffect(() => {
    if (singleClientMachine) {
      setState(structuredClone(singleClientMachine))
    }
  }, [singleClientMachine])

  const handleSubmit = async () => {

    if (state.ownership == 2 && !state.costPerHour) {
      toast.warning('Machine cost must be entered for selected ownership.')
      return
    }

    if (!state.name || !state.machineCategory?.id || !state.machineryModel?.id) {
      toast.warning('All required fields must be filled.')
      return
    }

    if (!state.name || !state.machineCategory?.id || !state.machineryModel?.id) {
      toast.warning('All required fields must be filled.')
      return
    }
    const resp = await dispatch(updateClientMachinery({ ...state, oldStatus: singleClientMachine.status }))
    if (resp.meta.requestStatus === 'fulfilled') {
      navigate('/machinery')
    }
  }


  return (
    <>
      <NavBar />
      <PageWrapper noFooter>
        <Flex between main>
          <H1WithBack
            title={'Edit ' + (singleClientMachine?.name ? singleClientMachine?.name : '')}
            arrow
          />

        </Flex>
        <ContentWrapper>
          <MachinerySpecificationTab
            state={state}
            setState={setState}
            handleSubmit={handleSubmit}
          />
        </ContentWrapper>

      </PageWrapper>
      <PageFooter>
        <Flex gap='1rem'>
          <CancelBtn />
          <Button orange onClick={handleSubmit}>
            Save
          </Button>
        </Flex>
      </PageFooter>
    </>
  )
}
